/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-duplicate-string */
import { makeStyles } from '@rentacenter/racstrap';

export const chatbotWindowStyles = () => {
  // Constants for repeated values
  const TRANSFORM_ORIGIN = '730px 150px';
  
  return makeStyles((theme) => ({
    /* Chatbot window container */
    chatbotWindow: {
      position: 'fixed',
      right: '24px',
      bottom: '80px',
      width: '376px',
      height: '600px',
      borderRadius: '12px',
      background: '#fff',
      boxShadow: '0 18px 40px rgba(0,0,0,0.22)',
      overflow: 'hidden',
      zIndex: 10001,
      [theme.breakpoints.down(1281)]: {
        width: '350px',
        height: '540px',
        right: '18px',
        bottom: '65px',
      },
      [theme.breakpoints.down(1024)]: {
        width: '330px',
        height: '510px',
        right: '16px',
        bottom: '60px',
      },
      [theme.breakpoints.down(992)]: {
        width: '320px',
        height: '490px',
        right: '16px',
        bottom: '60px',
      },
      [theme.breakpoints.down(768)]: {
        width: '300px',
        height: '470px',
        right: '14px',
        bottom: '55px',
      },
      [theme.breakpoints.down(480)]: {
        width: '92vw',
        height: '70vh',
        right: '12px',
        bottom: '84px',
      },
    },

    /* Close button */
    closeBtn: {
      position: 'absolute',
      top: '5px',
      right: '8px',
      width: '46px',
      height: '30px',
      display: 'grid',
      placeItems: 'center',
      borderRadius: '6px',
      background: '#fff',
      cursor: 'pointer',
      zIndex: 10002,
      userSelect: 'none',
      '&:hover': {
        background: '#f0f0f0',
      },
      '&:focus': {
        outline: '2px solid #438fff',
      },
      [theme.breakpoints.down(1024)]: {
        width: '42px',
        height: '28px',
      },
      [theme.breakpoints.down(768)]: {
        width: '38px',
        height: '26px',
      },
    },

    /* Close button icon container */
    closeBtnIcon: {
      position: 'relative',
      width: '18px',
      height: '18px',
      [theme.breakpoints.down(1024)]: {
        width: '16px',
        height: '16px',
      },
      [theme.breakpoints.down(768)]: {
        width: '14px',
        height: '14px',
      },
    },

    /* Close button lines */
    closeBtnLine1: {
      position: 'absolute',
      width: '18px',
      height: '2px',
      background: '#000',
      borderRadius: '2px',
      transform: 'rotate(45deg)',
      top: '8px',
      [theme.breakpoints.down(1024)]: {
        width: '16px',
        top: '7px',
      },
      [theme.breakpoints.down(768)]: {
        width: '14px',
        top: '6px',
      },
    },

    closeBtnLine2: {
      position: 'absolute',
      width: '18px',
      height: '2px',
      background: '#000',
      borderRadius: '2px',
      transform: 'rotate(-45deg)',
      top: '8px',
      [theme.breakpoints.down(1024)]: {
        width: '16px',
        top: '7px',
      },
      [theme.breakpoints.down(768)]: {
        width: '14px',
        top: '6px',
      },
    },

    /* Loader container */
    loaderContainer: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      zIndex: 10001,
    },

    /* Spinner animation */
    spinner: {
      width: '50px',
      height: '50px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #438fff',
      borderRadius: '50%',
      animation: '$spin 1s linear infinite',
      [theme.breakpoints.down(768)]: {
        width: '40px',
        height: '40px',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #438fff',
      },
    },

    /* Spinner keyframes */
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },

    /* Loading text */
    loadingText: {
      marginTop: '20px',
      fontSize: '16px',
      color: '#666',
      fontFamily: 'Open Sans, sans-serif',
      fontWeight: '400',
      [theme.breakpoints.down(768)]: {
        fontSize: '14px',
        marginTop: '16px',
      },
    },

    /* The iframe - adjusted for better chatbot visibility */
    chatbotIframe: {
      border: '0',
      width: '942px',
      height: '502px',
      transformOrigin: '152px -239px',
      transform: 'scale(1.50) translate(-600px, -150px)',
      transition: 'opacity 0.3s ease-in-out',
      [theme.breakpoints.down(1281)]: {
        width: '1440px',
        height: '900px',
        transformOrigin: TRANSFORM_ORIGIN,
        transform: 'scale(0.39) translate(-1080px, -210px)',
      },
      [theme.breakpoints.down(1024)]: {
        width: '1440px',
        height: '900px',
        transformOrigin: TRANSFORM_ORIGIN,
        transform: 'scale(0.37) translate(-1120px, -230px)',
      },
      [theme.breakpoints.down(992)]: {
        width: '1440px',
        height: '900px',
        transformOrigin: TRANSFORM_ORIGIN,
        transform: 'scale(0.36) translate(-1150px, -240px)',
      },
      [theme.breakpoints.down(768)]: {
        width: '1440px',
        height: '900px',
        transformOrigin: TRANSFORM_ORIGIN,
        transform: 'scale(0.34) translate(-1200px, -260px)',
      },
      [theme.breakpoints.down(480)]: {
        width: '1440px',
        height: '900px',
        transformOrigin: TRANSFORM_ORIGIN,
        transform: 'scale(0.32) translate(-1250px, -280px)',
      },
    },
  }))();
};
